import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { forwardRef } from 'react';
import StripeCardBox from './StripeCardBox';
import "./stripeCard.scss";
const StripeCard = forwardRef(({ onSaveCard, loading, setLoading, saveCard = false, publicKey}, ref) => {
  const stripePromise = loadStripe(publicKey || "");

  return (
    <Elements stripe={stripePromise}>
      <StripeCardBox
        onSaveCard={onSaveCard}
        loading={loading}
        setLoading={setLoading}
        saveCard={saveCard}
        ref={ref}
      />
    </Elements>
  )
})

export default StripeCard